import { render, staticRenderFns } from "./dialogueFacture.vue?vue&type=template&id=b54cafb2&scoped=true"
import script from "./dialogueFacture.vue?vue&type=script&lang=js"
export * from "./dialogueFacture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54cafb2",
  null
  
)

export default component.exports